import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_AdvisorSnippet } from './ModuleFE_AdvisorSnippet.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_AdvisorSnippet,
    modules: [ModuleFE_AdvisorSnippet],
    mapper: item => [item.label],
    placeholder: 'Choose an Advisor Snippet',
    renderer: item => _jsx("div", { children: item.label })
};
export const DropDown_AdvisorSnippet = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_AdvisorSnippet,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_AdvisorSnippet.selectable,
});
export const MultiSelect_AdvisorSnippet = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map